import { Injectable, NgZone } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class FlutterBridgeService {
    public _isFlutter$ = new BehaviorSubject<boolean>(false);


    public _isOfflineActivated$ = new BehaviorSubject<boolean>(false);


    constructor(private zone: NgZone) {
        console.log('FlutterBridgeService initialized');
        (window as any).onFlutterMessage = (msg: any) => {
            console.log('Message from Flutter:', msg);

            if (msg.trim() === 'FlutterApp') {
                this.zone.run(() => {
                    this._isFlutter$.next(true);
                });
            }
            if (msg.trim() === 'isOfflineActivated:true') {
                this.zone.run(() => {
                    this._isOfflineActivated$.next(true);
                });
            }
        };
    }



    sendMessageToFlutter(message: any) {
        const flutter = (window as any).flutter_inappwebview;
        if (flutter) {
            flutter.callHandler('FlutterChannel', message);
        }
    }
}
